// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { useCallback, useState as _useState } from 'preact/hooks';
export const useState = (initialState) => {
    const [state, setState] = _useState(initialState);
    const resetState = useCallback(() => {
        setState(initialState);
    }, [setState, initialState]);
    const updateState = useCallback((updateFn) => {
        setState(updateFn);
    }, [setState]);
    return { state, setState, updateState, resetState };
};
